"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleSwitch = void 0;
const react_1 = __importDefault(require("react"));
const react_toggle_1 = __importDefault(require("react-toggle"));
exports.ToggleSwitch = (_a) => {
    var { label, checked, onChange, labelPlacement = "end" } = _a, props = __rest(_a, ["label", "checked", "onChange", "labelPlacement"]);
    return (react_1.default.createElement("label", Object.assign({}, props),
        label && labelPlacement === "start" && react_1.default.createElement("span", null, label),
        react_1.default.createElement(react_toggle_1.default, { icons: false, checked: checked, onChange: onChange, className: "toggle-switch" }),
        label && labelPlacement === "end" && react_1.default.createElement("span", null, label)));
};
//# sourceMappingURL=ToggleSwitch.js.map